import { render, staticRenderFns } from "./MajorEdit.vue?vue&type=template&id=4830cb9b&scoped=true&"
import script from "./MajorEdit.vue?vue&type=script&lang=js&"
export * from "./MajorEdit.vue?vue&type=script&lang=js&"
import style0 from "./MajorEdit.vue?vue&type=style&index=0&id=4830cb9b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4830cb9b",
  null
  
)

export default component.exports